import { useId } from 'react';
import { SvgIcon } from '../SvgIcon';

export const EventsSurveyIcon = ({
	fillColor = '#C6CCD7',
	width = 19,
	height = 18,
}: {
	fillColor?: string;
	width?: number;
	height?: number;
}) => {
	const id = useId();

	return (
		<SvgIcon width={width} height={height} viewBox='0 0 19 18'>
			<g id={`${id}-Page-1`} stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
				<g id={`${id}-Updated-Survey-Icons`} transform='translate(-217, -156)' fill={fillColor}>
					<g id={`${id}-Group`} transform='translate(215, 155.0002)'>
						<g transform='translate(2, 0.9998)'>
							<g id={`${id}-Fill-1761-+-Fill-1762-Copy-2`}>
								<path
									d='M4.16666667,3.33406961 L1.66666667,3.33406961 L1.66666667,1.6670348 L4.16666667,1.6670348 L4.16666667,3.33406961 Z M16.6666667,3.33406961 L10,3.33406961 L10,1.6670348 L16.6666667,1.6670348 L16.6666667,3.33406961 Z M5.83333333,1.6670348 L8.33333333,1.6670348 L8.33333333,3.33406961 L5.83333333,3.33406961 L5.83333333,1.6670348 Z M1.66666667,5.00110441 L16.6666667,5.00110441 L16.665,9.16452383 L18.3333333,9.16452383 L18.3333333,1.6670348 C18.3333333,0.747665109 17.5858333,0 16.6666667,0 L1.66666667,0 C0.7475,0 0,0.747665109 0,1.6670348 L0,15.0033132 C0,15.9235164 0.7475,16.670348 1.66666667,16.670348 L8.33333333,16.670348 L8.33333333,15.0033132 L1.66666667,15.0033132 L1.66666667,5.00110441 Z'
									id={`${id}-Fill-1761`}
								/>
							</g>
							<g id={`${id}-Events-Icon`} transform='translate(10, 11)'>
								<polygon
									id={`${id}-Fill-1770`}
									points='3.54397706 7 0 3.35598933 1.35181644 1.96601601 3.54397706 4.22005336 7.64818356 0 9 1.38997332'
								/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</SvgIcon>
	);
};
